import { useEffect, useRef } from 'react';
type TCb = (val: Record<string, string>) => void;

export const separator = '($$)'; // 用于分隔hash的key-value 不要轻易动这个，这个是和小程序相关联的

// 将hash转换为对象
const hrefTransfer = (url: string) => {
  // 防止后面的参数有多个#，这里不用split
  const match = url.match(/#(.*?)$/);
  let hash = '';
  if (match) hash = match[1];

  const hashArr = hash.split(separator);
  const hashObj: Record<string, string> = {};
  hashArr.forEach((item) => {
    const [key, value] = item.split('=');
    if (key && value) hashObj[key] = decodeURIComponent(value);
  });
  return hashObj;
};

export const useHash = () => {
  const hashCbList = useRef<Record<string, TCb>>({});
  // 不希望重复注册
  useEffect(() => {
    const onHashChange = (e: HashChangeEvent) => {
      const hashObj = hrefTransfer(e.newURL);
      Object.values(hashCbList.current).forEach((cb) => {
        cb(hashObj);
      });
    };
    onHashChange({ newURL: location.href } as HashChangeEvent);
    window.addEventListener('hashchange', onHashChange);

    return () => {
      hashCbList.current = {};
      window.removeEventListener('hashchange', onHashChange);
    };
  }, []);
  /**
   * @example href: http://localhost:3000/?type=chat&chatID=252779562184425476#a=2
   *          cb: (val) => console.log(val) // {a: '2'}
   * @example href: http://localhost:3000/?type=chat&chatID=252779562184425476#a=2($$)b=4
   *          cb: (val) => console.log(val) // {a: '2', b: '4'}
   * @returns void
   */
  const addEvent = (cb: TCb) => (hashCbList.current[cb.toString()] = cb);
  const removeEvent = (cb: TCb) => delete hashCbList.current[cb.toString()];
  const onceEvent = (cb: TCb) => {
    const onceCb = (val: Record<string, string>) => {
      cb(val);
      removeEvent(onceCb);
    };
    addEvent(onceCb);
  };

  const getHash = () => hrefTransfer(window.location.href);

  return {
    addEvent,
    removeEvent,
    onceEvent,
    getHash,
  };
};
